// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".j9j2aWXUaJ2Eo5 {\n  position: absolute;\n  height: 64px;\n  width: 64px;\n  transition: transform 85ms ease-in, opacity 85ms ease-in;\n  -webkit-user-select: none;\n          user-select: none;\n}\n.pCFCJsbYAorI6Q {\n  height: 64px;\n  width: 64px;\n  color: transparent;\n  border: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sticker": "j9j2aWXUaJ2Eo5",
	"stickerImage": "pCFCJsbYAorI6Q"
};
export default ___CSS_LOADER_EXPORT___;
